export const PERMISSIONS = {
    // Products
    VIEW_PRODUCTS: 'view:product',
    CREATE_PRODUCTS: 'add:product',
    EDIT_PRODUCTS: 'update:product',
    DELETE_PRODUCTS: 'remove:product',
    // Collections
    VIEW_COLLECTIONS: 'view:collection',
    CREATE_COLLECTIONS: 'add:collection',
    EDIT_COLLECTIONS: 'update:collection',
    DELETE_COLLECTIONS: 'remove:collection',
    // Categories
    VIEW_CATEGORIES: 'view:category',
    CREATE_CATEGORIES: 'add:category',
    EDIT_CATEGORIES: 'update:category',
    DELETE_CATEGORIES: 'remove:category',
    // Review
    VIEW_REVIEW: 'view:review',
    CREATE_REVIEW: 'add:review',
    UPDATE_REVIEW: 'update:review',
    DELETE_REVIEW: 'remove:review',
    // Users
    VIEW_USERS: 'view:user',
    CREATE_USERS: 'add:user',
    EDIT_USERS: 'update:user',
    DELETE_USERS: 'remove:user',
    // Roles
    VIEW_ROLES: 'view:role',
    CREATE_ROLES: 'add:role',
    EDIT_ROLES: 'update:role',
    DELETE_ROLES: 'remove:role',
    // Order
    VIEW_ORDERS: 'view:order',
    CREATE_ORDERS: 'add:order',
    DELETE_ORDERS: 'update:order',
    EDIDELETE_BRANDST_ORDERS: 'remove:order',
    // Brands
    VIEW_BRANDS: 'view:brand',
    CREATE_BRANDS: 'add:brand',
    EDIT_BRANDS: 'update:brand',
    DELETE_BRANDS: 'remove:brand',
    // Discount
    VIEW_DISCOUNT: 'view:discount',
    CREATE_DISCOUNT: 'add:discount',
    EDIT_DISCOUNT: 'update:discount',
    DELETE_DISCOUNT: 'remove:discount',
    // Daily Spin
    VIEW_SPIN: 'view:daily spin',
    CREATE_SPIN: 'add:daily spin',
    EDIT_SPIN: 'update:daily spin',
    DELETE_SPIN: 'remove:daily spin',
    // Content
    VIEW_CONTENT: 'view:website content',
    CREATE_CONTENT: 'add:website content',
    EDIT_CONTENT: 'update:website content',
    DELETE_CONTENT: 'remove:website content',
    // Settings
    VIEW_SETTINGS: 'view:settings',
    CREATE_SETTINGS: 'add:settings',
    EDIT_SETTINGS: 'update:settings',
    DELETE_SETTINGS: 'remove:settings',
    // Verification
    SEND_VERIFICATION: 'send:verification',

} as const;

export const getPermissionName = (permission: Permission): string => {
    return permission.split(':')[1];
}
export type Permission = typeof PERMISSIONS[keyof typeof PERMISSIONS];